import { useState } from "react";
import { Button, Card, Col, Row, Table } from "react-bootstrap";
import API from "src/services/api";
import DeleteButton from "../DeleteButton";

const BusinessHourForm = ({ id, setValue, watch, swipeId }) => {
  const dayNames = [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag",
  ];
  const [days, setDays] = useState({
    0: false,
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
  });

  const items = watch(id, []).sort((a, b) => {
    if (a.day_of_week - b.day_of_week !== 0) {
      return a.day_of_week - b.day_of_week;
    }
    return a.start_time.localeCompare(b.start_time);
  });

  const [times, setTimes] = useState({ from: "", to: "" });

  const handleDayChange = (event) => {
    const { name, checked } = event.target;
    setDays((prevDays) => ({
      ...prevDays,
      [name]: checked,
    }));
  };

  const handleTimeChange = (event) => {
    const { name, value } = event.target;
    setTimes((prevTimes) => ({
      ...prevTimes,
      [name]: value,
    }));
  };

  const loadFromTA = async () => {
    const data = await API.loadSwipeTripadvisor(swipeId);
    console.log("Lade Öffnungszeiten von TA:", data);
    if (
      data?.data.detail?.hours?.periods &&
      data.data.detail.hours.periods.length > 0
    ) {
      const toAdd = data.data.detail.hours.periods.map((period) => ({
        day_of_week: period.open.day > 6 ? 0 : period.open.day,
        start_time:
          period.open.time.slice(0, 2) + ":" + period.open.time.slice(2, 4),
        end_time:
          period.close &&
          period.close.time.slice(0, 2) + ":" + period.close.time.slice(2, 4),
      }));

      setValue(id, [...items, ...toAdd]);
    } else {
      alert("Keine Öffnungszeiten bei TripAdvisor gefunden.");
    }
  };

  const handleSubmit = () => {
    console.log("Ausgewählte Tage:", days);
    console.log("Zeiten:", times);

    if (times.to && times.from) {
      const toAdd = [];
      Object.entries(days).forEach(([day, isChecked]) => {
        if (isChecked) {
          toAdd.push({
            day_of_week: day,
            start_time: times.from,
            end_time: times.to,
          });
        }
      });

      setValue(id, [...items, ...toAdd]);

      // State zurücksetzen
      setDays({
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
      });

      setTimes({ from: "", to: "" });
    }
  };

  const handleDelete = (indexToRemove) => {
    setValue(
      id,
      items.filter((_, index) => index !== indexToRemove),
    );
  };

  return (
    <Card body className="add-margin">
      <h2>Öffnungszeiten</h2>
      <Row className="add-margin">
        {Object.keys(days).map((day) => (
          <Col key={day}>
            <input
              className="form-check-input"
              type="checkbox"
              name={day}
              checked={days[day]}
              onChange={handleDayChange}
            />{" "}
            {dayNames[day]}
          </Col>
        ))}
      </Row>
      <Row className="add-margin">
        <Col>
          <input
            className="form-control"
            type="time"
            name="from"
            value={times.from}
            onChange={handleTimeChange}
          />
        </Col>
        <Col>
          <input
            className="form-control"
            type="time"
            name="to"
            value={times.to}
            onChange={handleTimeChange}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Button onClick={handleSubmit}>Hinzufügen</Button>
          {false && swipeId && (
            <Button onClick={loadFromTA}>Von TripAdvisor laden</Button>
          )}
        </Col>
      </Row>
      <hr />
      <Table>
        <tbody>
          {items.map((i, index) => (
            <tr>
              <th>{dayNames[i.day_of_week]}</th>
              <td>
                {i.start_time} - {i.end_time}
              </td>
              <td>
                <DeleteButton onClick={() => handleDelete(index)} />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Card>
  );
};

export default BusinessHourForm;
